var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',_vm._g(_vm._b({ref:"select",staticClass:"filter",attrs:{"rounded":"","outlined":"","dense":"","append-icon":"mdi-chevron-down"}},'v-autocomplete',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }